export default "__VITE_ASSET__D_pmf5gp__"